import React from 'react';
import PropTypes from 'prop-types';
import AdvertWrapper from "../../../Common/components/AdvertWrapper";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const AdvertStraplineWidget = ({bodyVisible, article, view}) => {
  return bodyVisible && !article.sensitive &&
    <AdvertWrapper ocSlot={["cms", "leaderboard"]}
                   additionalProperties={{view: view}}/>
};

AdvertStraplineWidget.mapProps = (props) => ({
  article: props.article,
  bodyVisible: props.bodyVisible,
  view: props.view
})
AdvertStraplineWidget.propTypes = {
  article: PropTypes.object,
  bodyVisible: PropTypes.bool,
  view: PropTypes.string
}

export default withErrorBoundary(AdvertStraplineWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/AdvertStrapline.widget.js